/**
 * Mapeamento Rota → Tela para controle de acesso
 *
 * Epic 27: Sistema de Controle de Acesso
 *
 * Mapeia cada rota frontend para o codigo de tela (dim_telas) correspondente.
 * Rotas SEM mapeamento sao acessiveis a todos os usuarios autenticados.
 * MASTER role sempre tem bypass (verificado no authStore.podeVisualizar).
 */

/**
 * Mapeamento de rotas para codigos de tela do backend.
 * Rotas com :param sao resolvidas via regex em resolveTelaFromPath().
 */
export const ROUTE_TELA_MAP: Record<string, string> = {
  // ── Operacional ──
  '/cloud/dashboard': 'DASHBOARD_VIEW',
  '/cloud/calendario': 'CALENDARIO_VIEW',
  '/cloud/gantt-chart': 'CALENDARIO_VIEW',
  '/cloud/contagens': 'CONTAGENS_LIST',
  '/cloud/contagens/:id': 'CONTAGENS_LIST',

  // ── Cadastros ──
  '/cloud/hospitais': 'HOSPITAIS_LIST',
  '/cloud/cadastroestabelecimentos': 'HOSPITAIS_LIST',
  '/cloud/clientes': 'CLIENTES_LIST',
  '/cloud/clientes/:id': 'CLIENTES_LIST',
  '/cloud/conferencia': 'CONFERENCIA_VIEW',
  '/cloud/conferencia/:id': 'CONFERENCIA_VIEW',
  '/cloud/produtos': 'PRODUTOS_LIST',
  '/cloud/escopo-contagem': 'ESCOPO_CONTAGEM_VIEW',

  // ── Relatorios ──
  '/cloud/relatorios': 'RELATORIOS_VIEW',
  '/cloud/downloads': 'DOWNLOADS_VIEW',

  // ── Bug Reports (T30: era alcançável por URL sem gating de tela) ──
  '/cloud/bug-reports': 'CONFIGURACOES_VIEW',

  // ── Admin ──
  '/cloud/controle-acesso': 'CONTROLE_ACESSO_VIEW',
  '/cloud/users': 'USUARIOS_LIST',
  '/cloud/usuarios': 'USUARIOS_LIST',
  '/cloud/logs': 'LOGS_VIEW',
  '/cloud/logs/access': 'LOGS_VIEW',
  // N129: leitura e MASTER-only no backend; a tela tambem barra quem nao e MASTER
  '/cloud/diagnosticos': 'LOGS_VIEW',
  // N226: idem -- sem esta linha a rota seria livre para qualquer autenticado
  '/cloud/logs/diagnostico-nuvem': 'LOGS_VIEW',
  '/cloud/configuracoes': 'CONFIGURACOES_VIEW',

  // ── Legacy Jobs ──
  '/jobs/new': 'CONTAGENS_LIST',
  '/jobs/:id': 'CONTAGENS_LIST',

  // ── Admin Tools (MASTER via CONFIGURACOES_VIEW) ──
  '/mobile/emulator': 'CONFIGURACOES_VIEW',
  '/mobile/flutter': 'CONFIGURACOES_VIEW',
  '/build-apk': 'CONFIGURACOES_VIEW',
  '/api-test': 'CONFIGURACOES_VIEW',
};

/**
 * Resolve um pathname para o codigo de tela correspondente.
 * Suporta rotas parametrizadas (ex: /cloud/contagens/123 → CONTAGENS_LIST).
 *
 * @returns codigo da tela ou null se nao houver mapeamento (rota livre)
 */
export function resolveTelaFromPath(pathname: string): string | null {
  // Match exato primeiro (mais performatico)
  if (ROUTE_TELA_MAP[pathname]) {
    return ROUTE_TELA_MAP[pathname];
  }

  // Match com parametros (:id, :slug, etc.)
  for (const [pattern, tela] of Object.entries(ROUTE_TELA_MAP)) {
    if (!pattern.includes(':')) continue;
    const regex = new RegExp(
      '^' + pattern.replace(/:[^/]+/g, '[^/]+') + '$'
    );
    if (regex.test(pathname)) {
      return tela;
    }
  }

  // Sem mapeamento = acessivel a todos os autenticados
  return null;
}
